<!--
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: smallWhite
 * @Date: 2023-05-12 20:36:16
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-05-30 14:32:26
 * @FilePath: /siana_admin/src/views/system/midjourney/index.vue
-->
<template>
  <el-card>
    <div slot="header">
      <h2>midjourney配置</h2>
    </div>
    <el-form ref="ruleForm"
      :model="form"
      :rules="rules"
      label-width="180px"
      :label-position="phone?'top':'right'"
      class="demo-ruleForm">
      <el-form-item
        label="是否开启midjourney"
        prop="isOpenMj">
        <el-select
          v-model="form.isOpenMj"
          :disabled="disabled"
          style="width:100%;max-width: 600px;"
          placeholder="请选择是否开启stablediffusion">
          <el-option
            label="关闭"
            :value="0" />
          <el-option
            label="开启"
            :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item
        label="discord服务器id"
        prop="mjGuildId">
        <el-input
          v-model="form.mjGuildId"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="discord频道id"
        prop="mjChannelId">
        <el-input
          v-model="form.mjChannelId"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="discord用户Token"
        prop="mjUserToken">
        <el-input
          v-model="form.mjUserToken"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="机器人token"
        prop="mjBotToken">
        <el-input
          v-model="form.mjBotToken"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="机器人名称"
        prop="mjBotName">
        <el-input
          v-model="form.mjBotName"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        v-if="!disabled">
        <el-button
          type="primary"
          @click="handleSubmit()">保存</el-button>
        <el-button
          @click="handleCancel()">取消</el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button
          type="primary"
          @click="disabled = !disabled">去编辑</el-button>

      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      phone: false,
      form: {
        isOpenMj: 0, // 注册模式  1 账号密码 2 邮箱注册 3 公众号
        mjGuildId: '', // gpt请求地址
        mjChannelId: '', // discord频道id
        mjUserToken: '', // discord用户Token
        mjBotToken: '', // 图片返回前缀地址
        mjBotName: '' // 机器人名称
      },
      disabled: true,
      rules: {
        isOpenMj: [{ required: false, message: '请选择是否开启', trigger: 'blur' }],
        mjGuildId: [{ required: false, message: '请输入', trigger: 'blur' }],
        mjChannelId: [{ required: false, message: '请输入', trigger: 'blur' }],
        mjUserToken: [{ required: false, message: '请输入', trigger: 'blur' }],
        mjBotToken: [{ required: false, message: '请输入', trigger: 'blur' }],
        mjBotName: [{ required: false, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.phone = JSON.parse(window.localStorage.getItem('phone'))
    this.getData()
  },
  methods: {
    getData() {
      this.$https('SYSTEMSETTING', {}).then(res => {
        this.form = {
          id: res.data.id,
          isOpenMj: res.data.isOpenMj,
          mjGuildId: res.data.mjGuildId, // gpt请求地址
          mjChannelId: res.data.mjChannelId, // discord频道id
          mjUserToken: res.data.mjUserToken, // discord用户Token
          mjBotToken: res.data.mjBotToken, // 图片返回前缀地址
          mjBotName: res.data.mjBotName // 机器人名称
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$https('SYSTEMEDIT', this.form).then(res => {
            if (res.status == 200) {
              this.$message.success('编辑成功！')
              this.disabled = true
            }
          })
        }
      })
    },
    handleCancel() {
      this.form = {
        id: '',
        mjGuildId: '', // gpt请求地址
        mjChannelId: '', // discord频道id
        mjUserToken: '', // discord用户Token
        mjBotToken: '', // 图片返回前缀地址
        mjBotName: '' // 机器人名称
      }
      this.getData()
      this.disabled = true
    }
  }
}
</script>

<style>
</style>
